import __request__ from "routing/request";
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.health/alerts", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
